import { render, staticRenderFns } from "./WerecommendHome.vue?vue&type=template&id=17bd49eb&"
import script from "./WerecommendHome.vue?vue&type=script&lang=js&"
export * from "./WerecommendHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports